import { useApi } from '@/shared/composables/useApi'

import type { ApiRequestOptions } from '@/shared/composables/useApi'

export const apiController = (endPoint: string) => {
  const { endPointUrl, apiPost, apiGet, apiDelete, apiPatch, apiPut } = useApi({ baseEndpoint: endPoint, joinSlash: true })

  // TODO: Remove lastTIme on all controllers
  const controllerPost = async <T, U>(payload: T, path?: string, lastTime?: boolean): Promise<U> => {
    const url = endPointUrl(path)
    try {
      const returnData: U = await apiPost(url, payload)
      return returnData
    } catch (error) {
      throw error
    }
  }

  const controllerGet = async <T>(path?: string, lastTime?: boolean, options?: ApiRequestOptions): Promise<T> => {
    const url = endPointUrl(path) as URL

    try {
      const returnData: T = await apiGet(url, options)
      return returnData
    } catch (error) {
      throw error
    }
  }

  const controllerPatch = async <T, U>(payload: T, path?: string, lastTime?: boolean): Promise<U> => {
    const url = endPointUrl(path)

    try {
      const returnData: U = await apiPatch(url, payload)
      return returnData
    } catch (error) {
      throw error
    }
  }

  const controllerDelete = async <T>(path?: string, lastTime?: boolean): Promise<T> => {
    const url = endPointUrl(path) as URL

    try {
      const returnData: T = await apiDelete(url)
      return returnData
    } catch (error) {
      throw error
    }
  }

  const controllerPut = async <T, U>(payload: T, path?: string): Promise<U> => {
    const url = endPointUrl(path)

    try {
      const returnData: U = await apiPut(url, payload)
      return returnData
    } catch (error) {
      throw error
    }
  }

  return {
    controllerPost,
    controllerGet,
    controllerPatch,
    controllerDelete,
    controllerPut
  }
}
